/**
 * Scoring types and VP constants for the Legendary Arena game engine.
 *
 * Defines the MVP VP table as named constants and the return types
 * for computeFinalScores. Scoring is a derived view — results are
 * never stored in G during MVP.
 */
// ---------------------------------------------------------------------------
// MVP VP Table (named constants — never inline numbers)
// ---------------------------------------------------------------------------
// why: D-24157 — VP_VILLAIN / VP_HENCHMAN / VP_TACTIC are now FALLBACKS. As of
// WP-365, computeFinalScores awards each villain / henchman / mastermind-tactic
// its PRINTED vp (from the G.cardVictoryPoints setup snapshot); these constants
// apply only when a card has no printed vp (null-vp cards must never score 0).
// VP_BYSTANDER and VP_WOUND remain the authoritative values (bystanders are 1 VP
// by rule; wounds are a fixed penalty). Card-text-specific VP modifiers ("this
// card is worth +N VP") are delivered for Supreme HYDRA (D-24355) in
// scoring/dynamicVictoryPoints.ts; other N* / dynamic-VP cards (Ultron, amwp,
// 3dtc) remain a future packet.
/** Fallback VP per villain when the card has no printed vp (D-24157). */
export const VP_VILLAIN = 1;
/** Fallback VP per henchman when the group has no printed vp (D-24157). */
export const VP_HENCHMAN = 1;
/** VP awarded per bystander in a player's victory pile (1 VP by rule). */
export const VP_BYSTANDER = 1;
/** Fallback VP per defeated tactic when the mastermind has no printed vp (D-24157). */
export const VP_TACTIC = 5;
/** VP penalty per wound in a player's zones (negative value). */
export const VP_WOUND = -1;
// why: WP-678 / D-24494 — a Hero (or any card) sent Undercover is worth 1 VP by rule
// (universal-rules-v23 §Undercover). Counted from the per-player `zones.undercover`
// tracker, one VP per entry — never inferred from card type (a classless S.H.I.E.L.D.
// Agent or an Officer with no cardTraits entry must still score 1).
/** VP awarded per card sent Undercover (1 VP by rule). */
export const VP_UNDERCOVER = 1;
export { PENALTY_EVENT_TYPES } from './parScoring.types.js';
//# sourceMappingURL=scoring.types.js.map